<template>
  <section class="hero">
    <div class="overlay-h1">
      <div class="col-12">
          <div class="">
            <h6>¡El FINAL BOSS de las experiencias inmersivas!</h6>
            <h4>BIENVENIDOS AL <em>SIGUIENTE NIVEL</em></h4>

            <div class="image text-center p-4 cursor-pointer" @click="isModalOpen = true">
              <img src="@/assets/images/PLAY2.svg" alt="" />
              <h3 class="">VER VIDEO</h3>
            </div>
            <div class="claim-message">
              <h5>En SPARK81, combinamos acción, tecnología y trabajo en equipo en nuestras <em>salas de acción arcade</em>. ¿Te atreves?</h5>
            </div>
            <div class="main-button">
              <a href="#" @click.prevent="() => {$router.push('/booking')}">RESERVA TU PARTIDA</a>
            </div>
        </div>

        </div>
    </div>

    <!-- Add Modal component -->
    <Modal :is-open="isModalOpen" @modal-close="isModalOpen = false">
      <template #content>
        <div class="video-container">
          <iframe
            width="100%"
            height="500"
            src="https://www.youtube.com/embed/6FhiJvQ-csQ?autoplay=1"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen>
          </iframe>
        </div>
      </template>
    </Modal>
  </section>

</template>

<script>
import { useRouter } from "vue-router";
import Modal from "@/components/Modal.vue";
import { ref } from 'vue';

export default {
  components: {
    Modal
  },
  setup() {
    const router = useRouter();
    const isModalOpen = ref(false);

    const goToBooking = () => {
      router.push("/booking");
    };

    return {
      goToBooking,
      isModalOpen
    };
  },
};
</script>

<style scoped>
.video-container {
  position: relative;
  padding-bottom: 56.25%; /* 16:9 aspect ratio */
  height: 0;
  overflow: hidden;
  background: #000;
  border-radius: 8px;
}

.video-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>